import Lenis from 'lenis';

let lenis = null;

// Smooth scrolling for the whole site. Skipped entirely for
// prefers-reduced-motion users, who get native instant scrolling.
export const initLenis = () => {
  if (lenis || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return lenis;
  lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
  const raf = (time) => {
    if (!lenis) return;
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
};

export const destroyLenis = () => {
  lenis?.destroy();
  lenis = null;
};

// Lenis drives scrolling via its own rAF loop, independent of the native
// `overflow` CSS property, so toggling body overflow alone doesn't stop
// background scroll behind an open modal - Lenis itself must be paused.
export const stopLenis = () => lenis?.stop();
export const startLenis = () => lenis?.start();

// Nav clicks go through Lenis (react-scroll's own animation loop would fight it).
export const scrollToSection = (id, offset = 0) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (lenis) lenis.scrollTo(target, { offset });
  else target.scrollIntoView();
};
